import { ProductTransactionStatus } from '../types/order/productTransactionStatus';
import { http } from '../util/https.util';
import { PaginatedResponse } from './common/paginatedResponse';

const LIST = '/api/product_transaction/status/list';

export namespace ProductTransactionStatusRequest {
  export const list = async (payload: { page: number }): Promise<PaginatedResponse<ProductTransactionStatus>> => {
    return (await http.post(LIST, payload)).data;
  };
}
